module.exports = __webpack_public_path__ + "static/media/web.6a019ab1.svg";